export const experienceData = [
    {
        id: 1,
        company: 'Design Bytes International',
        jobtitle: 'Frontend Developer (HTML, CSS, JS)',
        startYear: '2018',
        endYear: '2019'
    },
    {
        id: 2,
        company: 'Discretelogix, Islamabad',
        jobtitle: 'Mobile App Developer (React-native, Flutter)',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 3,
        company: 'Google Developers Student Club',
        jobtitle: 'Technical Lead & Web Dev (React/NEXT JS)',
        startYear: '2020',
        endYear: '2024'
    },
]